export default __webpack_public_path__ + "static/media/PPI-driveway-018.dea8d3fa.jpg";